// extracted by mini-css-extract-plugin
module.exports =  {"container":"yI2jS3Ms","heading":"MxT9bA2W"};